import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.group',
    modules: [
        R,
    ],
})
@Service('GroupStore')
export default class Store extends BaseStore {

    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('groups');
    }

}



// WEBPACK FOOTER //
// ./src/app/stores/group.js